export const createdColumn = { id: "timestamp", title: "Created At" };
export const actionsColumn = { id: "actions", title: "Actions" };
export const activeColumn = { id: "active", title: "Status" };
